var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    {
      staticClass: "mt-2",
      staticStyle: { "max-height": "65vh", "font-size": "12px" },
      attrs: { bordered: "", responsive: "", "sticky-header": "" },
    },
    [
      _c("colgroup", [
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "120px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
        _c("col", { staticStyle: { width: "100px" } }),
      ]),
      _c(
        "b-thead",
        { attrs: { "head-variant": "light" } },
        [
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { rowspan: "2" },
                },
                [_vm._v("지역")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { rowspan: "2" },
                },
                [_vm._v("일자")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { rowspan: "2" },
                },
                [_vm._v("진료과")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { colspan: "3" },
                },
                [_vm._v("라이브 DI 노출 수")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { colspan: "3" },
                },
                [_vm._v("라이브 DI 클릭 수")]
              ),
            ],
            1
          ),
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("전체")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의사 수")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의원 수")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("전체")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의사 수")]
              ),
              _c(
                "b-th",
                { staticStyle: { "text-align": "center", top: "40px" } },
                [_vm._v("의원 수")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tbody",
        [
          !_vm.gridVisible
            ? [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { colspan: "9" },
                    },
                    [
                      _vm._v(
                        " 라이브 DI 업데이트로 2025-08-28 이전 데이터는 제공되지 않습니다. "
                      ),
                    ]
                  ),
                ]),
              ]
            : _vm.data.length > 0
            ? [
                _vm._l(_vm.rows, function (row, rIdx) {
                  return [
                    _vm._l(row.liveDiDepts, function (dept, index) {
                      return [
                        _c(
                          "b-tr",
                          {
                            key: "daily-" + rIdx + "-" + index,
                            style:
                              row.regionName === "(미분류제외) 전체 합"
                                ? "background-color: rgba(127, 127, 255, 0.1);"
                                : "",
                          },
                          [
                            index === 0 && row.isRegionFirst
                              ? _c(
                                  "b-td",
                                  {
                                    staticStyle: { "text-align": "center" },
                                    attrs: { rowspan: row.regionRowSpan },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(/*지역*/ row.regionName) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            index === 0
                              ? _c(
                                  "b-td",
                                  {
                                    staticStyle: { "text-align": "center" },
                                    attrs: {
                                      rowspan: row.liveDiDepts.length + 1,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(/*일자*/ row.dateStr) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      /*진료과*/ dept.medicalDepartmentName
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*전체*/ dept.liveDiStatDetail
                                          .totalShowCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의사수*/ dept.liveDiStatDetail
                                          .doctorShowCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의원수*/ dept.liveDiStatDetail
                                          .hcpShowCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*전체*/ dept.liveDiStatDetail
                                          .totalClickCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의사수*/ dept.liveDiStatDetail
                                          .doctorClickCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "b-td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("$numberFormatter")(
                                        /*의원수*/ dept.liveDiStatDetail
                                          .hcpClickCount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    }),
                    _c(
                      "b-tr",
                      {
                        key: "daily-subtotal-" + rIdx,
                        staticClass: "h6 font-weight-bolder",
                        style: row.dateStr
                          ? "background-color: rgba(127, 127, 127, 0.2);"
                          : "background-color: rgba(127, 255, 127, 0.1);",
                      },
                      [
                        row.isRegionFirst && row.liveDiDepts.length === 0
                          ? _c(
                              "b-td",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { rowspan: row.regionRowSpan },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(/*지역*/ row.regionName) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "b-td",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { colspan: row.dateStr ? 1 : 2 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  /*소계 구분*/ row.dateStr
                                    ? "일자별 소계"
                                    : row.regionName === "(미분류제외) 전체 합"
                                    ? "전체 합계"
                                    : "지역별 소계"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 노출 전체*/ row.subTotal
                                      .totalShowCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 노출 의사수*/ row.subTotal
                                      .doctorShowCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 노출 의원수*/ row.subTotal
                                      .hcpShowCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 클릭 전체*/ row.subTotal
                                      .totalClickCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 클릭 의사수*/ row.subTotal
                                      .doctorClickCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "b-td",
                          { staticStyle: { "text-align": "center" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("$numberFormatter")(
                                    /*합계 클릭 의원수*/ row.subTotal
                                      .hcpClickCount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ]
            : [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { colspan: "9" },
                    },
                    [_vm._v(" 라이브 DI를 선택해 주세요. ")]
                  ),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }